<template>
  <div class="input-radio-select">
    <div class="input-radio-select__icon">
      <fa :icon="icon" fixed-width v-if="icon[0] !== ''"/>
    </div>  
    <div class="input-radio-select__buttons">
      <div 
        class="input-radio-select__button touch"
        :class="{ 'input-radio-select__button--active': selection.value === value }"
        v-for="selection in selections"
        :key="selection.value"
        @click="$emit('input', selection.value)"
      >
        {{ selection.label }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [ 'icon', 'selections', 'value']
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.input-radio-select {
  align-items: center;
  display: flex;
  justify-content: flex-start;

  &__icon {
    font-size: 2rem;

    svg {
      margin-right: 1rem;
    }
  }

  &__buttons {
    display: flex;
  }

  &__button {
    border: 0.2rem solid $white;
    border-right: none;
    font-size: 1.5rem;
    padding: 0.5em;
    min-width: 3rem;
    text-align: center;
    transition: background-color 0.15s ease-in;

    &:last-child {
      border-right: 0.2rem solid $white;
    }

    &--active {
      background-color: rgba($white, 0.3);
    }
  }
}
</style>

